import { RouteRecordRaw } from "vue-router";

const routes: RouteRecordRaw[] = [
    {
        name: 'email-verification',
        path: '/email-verification',
        component: () => import('./email-verification-page.vue'),
        meta: {
            layout: 'blank-layout'
        }
    },
]

export default routes;